import Vue from 'vue'
import MessageComponent from '../components/Message.vue'

let MessageConstructor = Vue.extend(MessageComponent)
let instance
let instances = [] // 确保初始化为空数组
let seed = 1

const Message = function(options) {
  // 连续点击时，先清除所有现有消息
  Message.closeAll()
  
  if (typeof options === 'string') {
    options = {
      message: options
    }
  }
  options = options || {}
  
  let userOnClose = options.onClose
  let id = 'message_' + seed++
  
  options.onClose = function() {
    Message.close(id, userOnClose)
  }
  
  instance = new MessageConstructor({
    data: options
  })
  
  instance.id = id
  instance.$mount()
  document.body.appendChild(instance.$el)
  
  let verticalOffset = options.offset || 20
  // 由于我们已经清除了所有消息，这里不需要累加高度
  instance.offset = verticalOffset
  instance.visible = true
  
  // 确保 instances 是数组
  if (!Array.isArray(instances)) {
    instances = []
  }
  instances.push(instance)
  return instance
}

// 不同类型的快捷方法
if (Array.isArray(['success', 'warning', 'info', 'error'])) {
  ['success', 'warning', 'info', 'error'].forEach(type => {
    Message[type] = (options) => {
      if (typeof options === 'string') {
        options = {
          message: options
        }
      }
      options.type = type
      return Message(options)
    }
  })
}

Message.close = function(id, userOnClose) {
  if (!Array.isArray(instances)) {
    instances = []
    return
  }
  
  let len = instances.length
  let index = -1
  let removedHeight
  
  for (let i = 0; i < len; i++) {
    if (instances[i] && id === instances[i].id) {
      removedHeight = instances[i].$el ? instances[i].$el.offsetHeight : 0
      index = i
      if (typeof userOnClose === 'function') {
        userOnClose(instances[i])
      }
      instances.splice(i, 1)
      break
    }
  }
  
  if (len <= 1 || index === -1 || index > instances.length - 1) return
  
  for (let i = index; i < len - 1; i++) {
    if (instances[i] && instances[i].$el) {
      let dom = instances[i].$el
      dom.style['top'] = parseInt(dom.style['top'], 10) - removedHeight - 16 + 'px'
    }
  }
}

Message.closeAll = function() {
  if (!Array.isArray(instances)) {
    instances = []
    return
  }
  
  for (let i = instances.length - 1; i >= 0; i--) {
    if (instances[i] && typeof instances[i].close === 'function') {
      instances[i].close()
    }
  }
}

export default Message